import {Cos2} from "./RampAlgorithm";

export default class Ramp {
    private readonly change: (toVolume: number) => void;
    private readonly durationOnMS = 160;
    private readonly durationOffMS = 180;
    private readonly algorithm = new Cos2();

    constructor(change: (toVolume: number) => void) {
        this.change = change;
    }

    async on(toVolume: number = 1) {
        const intervalMS = this.durationOnMS / this.algorithm.steps.length;
        let factor = 0;
        while (factor < 1) {
            factor = this.algorithm.stepUp();
            const volume = factor * toVolume;
            this.change(volume);
            if (factor < 1) await this.sleep(intervalMS);
        }
    }

    async off(fromVolume: number = 1) {
        const intervalMS = this.durationOffMS / this.algorithm.steps.length;
        let factor = 1;
        while (factor > 0) {
            factor = this.algorithm.stepDown();
            const volume = fromVolume * factor;
            this.change(volume);
            if (factor > 0) await this.sleep(intervalMS);
        }
    }

    private sleep(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

}